<script setup>
import {onMounted, defineEmits, ref, defineProps, defineExpose} from 'vue'

let emit = defineEmits(['changed'])

const props = defineProps({
  activeRequestFields: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const defaultFormData = {
  offer_url: '',
  target_regions: '',
  headlines: '',
  descriptions: '',
}
let formData = ref(cloneSafe(defaultFormData))

onMounted(() => {
  init()
})

const init = () => {
  if (props.activeRequestFields) {
    formData.value = Object.assign(formData.value, props.activeRequestFields)
  }
}

const resetForm = () => {
  formData.value = cloneSafe(defaultFormData)
}

const onChange = () => {
  emit('changed', {fields: formData.value})
}

defineExpose({resetForm})
</script>

<template>
  <div class="form-group">
    <label for="bing-dating-wl-offer_url">Offer URL *</label>
    <div class="input-group">
      <input
        v-model="formData.offer_url"
        @change="onChange"
        class="form-control"
        id="bing-dating-wl-offer_url"
        type="url"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="bing-dating-wl-target_regions">Target Regions *</label>
    <div class="input-group">
      <input
        v-model="formData.target_regions"
        @change="onChange"
        class="form-control"
        id="bing-dating-wl-target_regions"
        type="text"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="bing-dating-wl-headlines">
      Headlines * <small class="muted">(minimum of 3, one per line)</small>
    </label>
    <div class="input-group">
      <textarea
        v-model="formData.headlines"
        @change="onChange"
        class="form-control"
        id="bing-dating-wl-headlines"
        :disabled="disabled"
        rows="3"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="bing-dating-wl-descriptions">
      Descriptions * <small class="muted">(minimum of 3, one per line)</small>
    </label>
    <div class="input-group">
      <textarea
        v-model="formData.descriptions"
        @change="onChange"
        class="form-control"
        id="bing-dating-wl-descriptions"
        :disabled="disabled"
        rows="3"
        required
      />
    </div>
  </div>
</template>
